module.exports = __webpack_public_path__ + "static/media/friend_pryan187.7187c649.gif";